export default __webpack_public_path__ + "static/media/comments.16973c6e.svg";